module.exports = __webpack_public_path__ + "static/media/unsupported.339acbb7.svg";